<template>
  <ul class="list-none p-0 m-0 border-top-1 border-300 ">
    <slot></slot>

    <template v-if="items">
      <BaseInfoTableItem
        v-for="(item, i) in items"
        :key="i"
        v-bind="item"
      />
    </template>
  </ul> 
</template>

<script setup lang="ts">
import BaseInfoTableItem from './BaseInfoTableItem.vue';

export type IBaseInfoTableItem = {
  label: string,
  text: string
}

defineProps<{
  items?: IBaseInfoTableItem[]
}>()
</script>